import Main from "./components/general/Main.vue";
import LandingPage from "./components/landingpage/LandingPage.vue"
import LoginPage from "./components/loginpage/LoginPage.vue"
import LogOut from "./components/LogOut/LogOut.vue"
import AssetSelector from "./components/assetSelector/assetSelector.vue"
//import Search from "./components/SearchComponent/SearchComponent.vue"
//import Portfolio from "./components/portfolio-dashboard-components/PortfolioDashboard/PortfolioDashboard.vue"
import ContentBlocker from "./components/contentBlocker/ContentBlocker.vue"
//import AssetDetail from "./components/AssetDetail/AssetDetail.vue"
//import Portfolios from "./components/portfolios/Portfolios.vue"
import DisclosurePage from "./components/DisclosurePage/DisclosurePage.vue"
//import UserPage from "./components/UserPage/UserPage.vue"
import ContactPage from "./components/ContactPage/ContactPage.vue"
import DataPolicyPage from "./components/DataPolicyPage/DataPolicyPage.vue"
import SigmafolioModel from "./components/SigmafolioModel/SigmafolioModel.vue"
import ShareablePortfolio from "./components/shareable-portfolio/PortfolioDashboard/PortfolioDashboard.vue"
//import SecurityRanking from "./components/SecurityRanking/SecurityRanking.vue"

export const routes = [{
    path: "", 
    component: Main,
    children: [{
        path: "/",
        name: "landingPage",
        component: LandingPage
    },
    {
        path: "/login",
        name: "loginPage",
        component: LoginPage//() => import('./components/loginpage/LoginPage.vue')
    },
    {
        path: "/logout",
        name: "LogOut",
        component: LogOut//() => import('./components/LogOut/LogOut.vue')
    },
    {
        path: "/sigmafolio-algorithmus",
        name: "SigmafolioModel",
        component: SigmafolioModel//() => import('./components/LogOut/LogOut.vue')
    },
    {
        path: "/assetSelector",
        name: "assetSelector",
        component: AssetSelector
    },
    {
        path: "/search",
        name: "Search",
        component: () => import(/* webpackChunkName: "groupLoggedIn" */ './components/SearchComponent/SearchComponent.vue')
    },
    {
        path: "/portfolio/:PORTFOLIO_ID",
        name: "portfolio/:PORTFOLIO_ID",
        component: () => import(/* webpackChunkName: "groupLoggedIn" */ './components/portfolio-dashboard-components/PortfolioDashboard/PortfolioDashboard.vue')
    },
    {
        path: "/accessDenied",
        name: "accessDenied",
        component: ContentBlocker//() => import('./components/contentBlocker/ContentBlocker.vue')
    }
    ,
    {
        path: "/assetDetail/:ISIN",
        name: "assetDetail/:ISIN",
        component: () => import(/* webpackChunkName: "groupLoggedIn" */ './components/AssetDetail/AssetDetail.vue')
    },
    { path: '/indexInformation', redirect: '/indexInformation/DE0008469008' },
    {
        path: "/indexInformation/:ISIN",
        name: "indexInformation/:ISIN",
        component: () => import('./components/IndexInformation/IndexInformation.vue')
    },
    {
        path: "/portfolios",
        name: "portfolios",
        component: () => import(/* webpackChunkName: "groupLoggedIn" */ './components/portfolios/Portfolios.vue')
    },
    {
        path: "/account",
        name: "account",
        component: () => import(/* webpackChunkName: "groupLoggedIn" */ './components/UserPage/UserPage.vue')
    },
    {
        path: "/securityRanking",
        name: "securityRanking",
        component: () => import(/* webpackChunkName: "groupLoggedIn" */ './components/SecurityRanking/SecurityRanking.vue')
    },
    {
        path: "/impressum",
        name: "impressum",
        component: DisclosurePage//() => import('./components/portfolio-dashboard-components/PortfolioDashboard/PortfolioDashboard.vue')
    },
    {
        path: "/kontakt",
        name: "kontakt",
        component: ContactPage//() => import('./components/portfolio-dashboard-components/PortfolioDashboard/PortfolioDashboard.vue')
    },
    {
        path: "/datenschutz",
        name: "datenschutz",
        component: DataPolicyPage//() => import('./components/portfolio-dashboard-components/PortfolioDashboard/PortfolioDashboard.vue')
    },
    {
        path: "/shareablePortfolio/:id",
        name: "shareablePortfolio/:id",
        component: ShareablePortfolio//() => import('./components/portfolio-dashboard-components/PortfolioDashboard/PortfolioDashboard.vue')
    },
    {
        path: "/:pathMatch(.*)*",
        beforeEnter () {
            window.location = '/'
          },
        name: "404-redirect",
        component: LandingPage
    },

]
}]